import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    t: require("./english.json"),
  },
  he: {
    t: require("./hebrew.json"),
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "he",
    lng: "he",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
